module.exports = __webpack_public_path__ + "img/section-main-logo.f8c183c2.svg";